import { FETCH_STORE_REQUEST, FETCH_STORE_SUCCESS, FETCH_STORE_FAILURE, } from "../../actions";
const initialState = {
    fetchData: null,
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_STORE_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case FETCH_STORE_SUCCESS:
            return Object.assign(Object.assign({}, state), { fetchData: action.payload, isLoading: false, error: null });
        case FETCH_STORE_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        default:
            return state;
    }
};
export default reducer;
